var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnWarningGrey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 8.84375V6.15625H6.84375V8.84375H8.15625ZM8.15625 11.5V10.1562H6.84375V11.5H8.15625ZM0.15625 13.5L7.5 0.84375L14.8438 13.5H0.15625Z",
    fill: "#E1E1E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnWarningGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-warning-grey.60e82120.svg";
export { ForwardRef as ReactComponent };